import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';
import TooltipDisclaimer from '@app/components/common/Availability/TooltipDisclaimer';
import { useSelector } from 'react-redux';

const AvailabilityHeader = ({
  translationKey,
  isQuantityMergeEnabled = true,
  labelClassName = '',
  ClassName = ''
}) => {
  const [t] = useTranslation();

  const AvailabilityForUnmergedCart = useSelector(
    s => !!s?.featureFlag?.PCC_AvailabilityForUnmergedCart
  );
  return (
    <div className={`d-flex ${styles['table-header-text']} ${ClassName}`}>
      <span className={`my-0 ${styles['table-header-text']} ${labelClassName}`}>
        {t(translationKey)}
        {!isQuantityMergeEnabled && (
          <div>{!AvailabilityForUnmergedCart && <sup>&dagger;</sup>}</div>
        )}
      </span>
      <TooltipDisclaimer />
    </div>
  );
};
AvailabilityHeader.propTypes = {
  translationKey: PropTypes.string,
  isQuantityMergeEnabled: PropTypes.bool,
  labelClassName: PropTypes.string,
  ClassName: PropTypes.string
};
export default AvailabilityHeader;
